let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '服务器id',
        props: 'userNo',
        minWidth: 300,
    },
    {
        label: '服务器名称',
        props: 'userName',
        minWidth: 200,
        tooltip:true,
    },
    {
        label: '服务器地址',
        props: 'userPhone',
        minWidth: 200,
    },
    {
        label: '创建人',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新人',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '更新时间',
        props: 'createdWhen',
        minWidth: 200,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '基础信息配置',
},
{
    type: 'router',
    name: '公司信息管理',
    router: 'companyManageList'
},];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: false,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'userId',
    editRouter: 'serverDetail',
};

// 路由
pageConfig.listRouter = 'serverManage';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '基础信息配置',
},
{
    type: 'router',
    name: '公司信息管理',
    router: 'serverManage'
},
{
    type: 'title',
    name: '创建',
}];

pageConfig.formRules = {
    userName: [{
        required: true,
        message: '请填写用户名',
        trigger: 'blur'
    }],
    userPassword: [{
        required: true,
        message: '请设置密码',
        trigger: 'blur'
    }],
    describe: [{
        required: true,
        message: '请填写账号描述',
        trigger: 'blur'
    }],
    status: [{
        required: true,
        message: '请填写账号状态',
        trigger: 'blur'
    }],
    dataCheck: [{
        required: true,
        message: '请选择账号归属',
        trigger: 'blur'
    }],
    userPhone: [{
        required: true,
        message: '请填写手机号',
        trigger: 'blur'
    },
    {
        pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
        message: '手机号填写错误',
        trigger: 'blur'
    }
],
    email: [{
        required: true,
        message: '请填写邮箱',
        trigger: 'blur'
    },
    {
        pattern: /^[a-zA-Z0-9_.-]+@[A-Za-z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
        message: '邮箱格式有误',
        trigger: 'blur'
    }
    ],
    area: [
        {
            required: true,
            message: '请选择角色权限',
            trigger: 'change',
            // 官网提供了对象的嵌套验证,只需要把需要验证的属性,放在fields对象里,就会按顺序进行验证
            fields: {
                province: {required: true, message: '请选择州省', trigger: 'blur'},
                city: {required: true, message: '请选择城市', trigger: 'blur'},
                district: {required: true, message: '请选择区县', trigger: 'blur'},
            }
        }
    ],
    dealNo: [{
        required: true,
        message: '请选择运营商',
        trigger: 'change'
    }],
};



export default pageConfig;